import { DayOfWeek, QueryFactory } from '@lmt/shared-types';
import { useIsAuthorized } from '@lmt/unicorn-shared/app/features/auth/operations';

export function useFirstDayOfWeek(): DayOfWeek {
  const isAuth = useIsAuthorized();
  const calendarSettingsQuery = QueryFactory.CalendarSettingsQuery.useGetQuery({
    enabled: isAuth === true,
    // is needed because it's used from MuiProvider which is outside of error scope
    throwOnError: false,
  });
  return calendarSettingsQuery.data?.firstDayOfWeek ?? 1;
}
